import { globalSettings } from 'app/globalSettings'
import React from 'react'
import styled from 'styled-components'

import { EFIcon, FacebookIcon, InstagramIcon, LinkedinIcon } from './icons'

type Props = {
  color: string
  size?: 'lg' | 'md'
  alignCenter?: boolean
  className?: string
}

export const SocialIcons = ({
  color,
  alignCenter,
  size,
  className,
  children,
}: WithChildren<Props>): JSX.Element => {
  const { facebookUrl, instagramUrl, linkedinUrl, efUrl } = globalSettings

  const iconSize = size === 'lg' ? 64 : 32

  return (
    <Wrapper alignCenter={alignCenter} className={className}>
      {children && <Header>{children}</Header>}

      <SocialList>
        <li>
          <a href={facebookUrl} target='_blank' rel='noopener noreferrer'>
            <FacebookIcon size={iconSize} color={color} />
          </a>
        </li>
        <li>
          <a href={efUrl} target='_blank' rel='noopener noreferrer'>
            <EFIcon size={iconSize} color={color} />
          </a>
        </li>
        <li>
          <a href={linkedinUrl} target='_blank' rel='noopener noreferrer'>
            <LinkedinIcon size={iconSize} color={color} />
          </a>
        </li>
        <li>
          <a href={instagramUrl} target='_blank' rel='noopener noreferrer'>
            <InstagramIcon size={iconSize} color={color} />
          </a>
        </li>
      </SocialList>
    </Wrapper>
  )
}

type WrapperProps = Pick<Props, 'alignCenter'>

const Wrapper = styled.div<WrapperProps>`
  text-align: ${({ alignCenter }) => (alignCenter ? 'center' : 'start')};
`

const Header = styled.div``

const SocialList = styled.ul`
  list-style: none;
  line-height: 0; //To fix bottom
  margin: 1rem 0;

  padding: 0;

  > li {
    display: inline-block;
  }

  > li:not(:first-child) {
    margin-left: 1rem;

    @media (min-width: ${({ theme }) => theme.bp.tablet}) {
      margin-left: 2rem;
    }
  }
`
